/* eslint-disable no-unused-vars */
import React from "react";
 
const Cardsk = () => {
  return (
    <div className="border p-4 rounded shadow-2xl w-[80%] max-w-[500px]">
      <div className="relative h-60 mb-4">
        <img
          className="absolute w-full h-full object-cover rounded"
          src="https://img.freepik.com/free-vector/abstract-coming-soon-halftone-style-background-design_1017-27282.jpg" 
        />
      </div>
      <div>
        <p className="font-semibold"> {/* Comming Soon  */}</p>{/* 
        <p className="text-sm pb-2">Price: $298</p>
        <p className="font-thin">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident
          libero similique et consequuntur velit laudantium, a dolorem
          reprehenderit? Quas, odit.
        </p> */}
      </div>
    </div>
  );
};

export default Cardsk;
